// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3c87a79d","453":"9306ab82","455":"f5fe2471","977":"49c19321"}[chunkId] + ".chunk.js";
};